// https://taxonomy.nucc.org/

import { SnomedCT, SnomedCTExpertiseLabel } from "@shared/enums/snomed-ct";

export const DoctorRoles = [
  {
    value: SnomedCT.GeneralPractitionerPrincipal, // https://www.snomedbrowser.com/Codes/Details/309394004
    label: SnomedCTExpertiseLabel.GeneralPractitionerPrincipal,
  },
  {
    value: SnomedCT.Dermatologist, // https://www.snomedbrowser.com/Codes/Details/18803008
    label: SnomedCTExpertiseLabel.Dermatologist,
  },
  {
    value: SnomedCT.Gynecologist, // https://www.snomedbrowser.com/Codes/Details/83685006
    label: SnomedCTExpertiseLabel.Gynecologist,
  },
  {
    value: SnomedCT.Ophtalmologist, // https://www.snomedbrowser.com/Codes/Details/422234006
    label: SnomedCTExpertiseLabel.Ophtalmologist,
  },
  {
    value: SnomedCT.GeriatricsSpecialist, // https://www.snomedbrowser.com/Codes/Details/90655003
    label: SnomedCTExpertiseLabel.GeriatricsSpecialist,
  },
];
